"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCarouselSlide = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationUtils = require("@ori/presentation-utils");
const StyledCarouselSlide = exports.StyledCarouselSlide = (0, _mui.styled)(_presentationComponents.CarouselSlide, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['index', 'spacing'])
})(({
  index,
  spacing
}) => ({
  transform: `translate3d(${spacing * index}px, 0px, 0px)`
}));
